import React, { useState } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, CheckCircleIcon } from 'lucide-react';
const packs = [{
  id: 'avanzado',
  icon: '📗',
  title: 'PACK AVANZADO',
  price: '$19.990',
  href: 'https://checkout.guiadigital360.online/cart/44131411918917:1',
  accent: 'brand-orange'
}, {
  id: 'primaria',
  icon: '🎓',
  title: 'PACK PRIMARIA',
  subtitle: 'Ciencias Naturales 1° a 7° grado',
  price: '$14.990',
  href: 'https://checkout.guiadigital360.online/cart/44812990218309:1',
  accent: 'purple-600'
}, {
  id: 'vip',
  icon: '🚀',
  title: 'COMBO VIP',
  subtitle: 'Pack Avanzado + Gestión Total VIP',
  price: '$24.990',
  href: 'https://checkout.guiadigital360.online/cart/44777826648133:1',
  accent: 'brand-blue'
}];
export function FinalCTASection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const [selected, setSelected] = useState<string>('avanzado');
  const selectedPack = packs.find(p => p.id === selected)!;
  const getButtonText = () => {
    if (selected === 'avanzado') return '→ QUIERO MI MEGAPACK AVANZADO';
    if (selected === 'primaria') return '→ QUIERO MI PACK PRIMARIA';
    return '→ QUIERO COMBO VIP';
  };
  const getButtonClass = () => {
    if (selected === 'vip') {
      return 'bg-brand-blue hover:bg-blue-700 shadow-[0_8px_25px_-5px_rgba(0,87,217,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(0,87,217,0.7)]';
    }
    if (selected === 'primaria') {
      return 'bg-purple-600 hover:bg-purple-700 shadow-[0_8px_25px_-5px_rgba(147,51,234,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(147,51,234,0.7)]';
    }
    return '';
  };
  return <section className="py-14 md:py-24 px-4 bg-brand-dark text-white text-center" data-id="element-84">
      <div className="max-w-2xl mx-auto" data-id="element-85">
        <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full mb-5 md:mb-8 border border-white/20" data-id="element-86">
          🧬 BIOLOGÍA EN ACCIÓN
        </div>

        <h2 className="text-2xl md:text-5xl font-black mb-5 md:mb-8 leading-tight" data-id="element-87">
          El próximo domingo podés seguir buscando material en Google.
          <br data-id="element-88" />
          <span className="text-brand-orange" data-id="element-89">
            O podés tener todo resuelto desde hoy.
          </span>
        </h2>

        <div className="bg-[#252542] p-5 md:p-8 rounded-3xl border border-gray-700 mb-8 md:mb-10" data-id="element-90">
          <p className="text-lg md:text-xl font-bold text-gray-300 mb-4" data-id="element-91">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className={`flex justify-center gap-4 mb-4 ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-92">
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-93">
              {formatTime(minutes)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-94">min</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-95">
              :
            </div>
            <div className={`text-4xl md:text-5xl font-black ${isUrgent ? 'text-red-500' : 'text-brand-orange'}`} data-id="element-96">
              {formatTime(seconds)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-97">seg</span>
            </div>
          </div>
          <p className="text-red-400 font-bold text-sm" data-id="element-98">
            Después sube $10.000 ARS y no vuelve.
          </p>
        </div>

        {/* Selectable Packs */}
        <div className="space-y-3 mb-6 text-left" data-id="element-99">
          {packs.map(pack => {
          const isSelected = selected === pack.id;
          return <button key={pack.id} onClick={() => setSelected(pack.id)} className={`w-full rounded-xl p-4 transition-all duration-200 flex items-center gap-3
                  ${isSelected ? pack.id === 'avanzado' ? 'bg-white text-brand-dark border-3 border-brand-orange shadow-xl' : pack.id === 'primaria' ? 'bg-white text-brand-dark border-3 border-purple-600 shadow-xl' : 'bg-white text-brand-dark border-3 border-brand-blue shadow-xl' : 'bg-[#252542] text-white border border-gray-700 opacity-70 hover:opacity-100'}`} data-id="element-100">
                {/* Radio */}
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? pack.id === 'avanzado' ? 'border-brand-orange bg-brand-orange' : pack.id === 'primaria' ? 'border-purple-600 bg-purple-600' : 'border-brand-blue bg-brand-blue' : 'border-gray-500'}`} data-id="element-101">
                  {isSelected && <CheckCircleIcon className="w-4 h-4 text-white" data-id="element-102" />}
                </div>

                <div className="flex-grow flex flex-col md:flex-row md:items-center md:justify-between gap-1" data-id="element-103">
                  <div data-id="element-104">
                    <h3 className="text-base md:text-lg font-black flex items-center gap-2" data-id="element-105">
                      {pack.icon} {pack.title}
                    </h3>
                    {pack.subtitle && <p className={`text-xs ${isSelected ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-106">
                        {pack.subtitle}
                      </p>}
                  </div>
                  <span className={`text-xl md:text-2xl font-black whitespace-nowrap ${isSelected ? pack.id === 'avanzado' ? 'text-brand-orange' : pack.id === 'primaria' ? 'text-purple-600' : 'text-brand-blue' : 'text-white'}`} data-id="element-107">
                    {pack.price}
                  </span>
                </div>
              </button>;
        })}
        </div>

        {/* Single CTA */}
        <div className="mb-8" data-id="element-108">
          <CTAButton text={getButtonText()} href={selectedPack.href} isLink={true} className={getButtonClass()} data-id="element-109" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm text-gray-400 font-medium" data-id="element-110">
          <span className="flex items-center gap-1.5" data-id="element-111">
            <LockIcon className="w-4 h-4" data-id="element-112" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-113">
            <ZapIcon className="w-4 h-4 text-yellow-500" data-id="element-114" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-115">
            <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-116" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-117">
            <CreditCardIcon className="w-4 h-4" data-id="element-118" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}